export default __webpack_public_path__ + "4df9d2a321ac82aa34242a7ed287a343.png";